/**
 * Represents a successfully uploaded file with its S3 URL.
 */
export class UploadedFileModel {
  public fileId!: string;
  public fileUrl!: string;
  public fileName!: string;
  public fileSizeBytes!: number;
  public contentType!: string;
}
